const comparisonRows = [
  { feature: 'Research Speed', manual: 'Low', spreadsheet: 'High' },
  { feature: 'Organization', manual: 'Poor', spreadsheet: 'Structured' },
  { feature: 'Comparison', manual: 'Difficult', spreadsheet: 'Easy' },
  { feature: 'Beginner Friendly', manual: 'Medium', spreadsheet: 'High' },
  { feature: 'Information Management', manual: 'Limited', spreadsheet: 'Advanced' },
  { feature: 'Data Retrieval', manual: 'Slow', spreadsheet: 'Instant' },
  { feature: 'Decision Confidence', manual: 'Low', spreadsheet: 'High' },
];

export default function ComparisonSection() {
  return (
    <section id="comparison" className="py-16 md:py-20 bg-background-100">
      <div className="container-custom">
        <div className="text-center mb-10">
          <span className="inline-block px-3 py-1 rounded-full bg-accent-100 text-accent-800 text-xs font-semibold mb-3 uppercase tracking-wide">
            Comparison
          </span>
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-900 mb-3">
            Superbuy Spreadsheet vs Manual Searching
          </h2>
          <p className="text-foreground-600 max-w-xl mx-auto text-sm md:text-base">
            See how our organized spreadsheet approach outperforms traditional manual browsing across every metric that matters.
          </p>
        </div>

        <div className="max-w-3xl mx-auto overflow-hidden rounded-xl border border-background-200/70">
          <table className="w-full">
            <thead>
              <tr className="bg-foreground-900">
                <th className="text-left p-4 text-background-50 font-heading font-semibold text-sm">Feature</th>
                <th className="text-center p-4 text-background-100 font-heading font-semibold text-sm">Manual Searching</th>
                <th className="text-center p-4 text-primary-400 font-heading font-semibold text-sm">Superbuy Spreadsheet</th>
              </tr>
            </thead>
            <tbody>
              {comparisonRows.map((row, idx) => (
                <tr
                  key={row.feature}
                  className={`border-t border-background-200/60 ${
                    idx % 2 === 0 ? 'bg-background-50' : 'bg-background-100/50'
                  }`}
                >
                  <td className="p-4 text-foreground-800 text-sm font-medium">{row.feature}</td>
                  <td className="p-4 text-center text-foreground-500 text-sm">{row.manual}</td>
                  <td className="p-4 text-center">
                    <span className="inline-flex items-center gap-1.5 text-accent-700 text-sm font-semibold">
                      {row.spreadsheet}
                      <i className="ri-check-line text-accent-500"></i>
                    </span>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </section>
  );
}